export function authHeaders(user, extra = {}) {
  const token = localStorage.getItem("authToken");
  return {
    ...extra,
    "x-user-role": String(user?.role || ""),
    ...(user?.id ? { "x-user-id": String(user.id) } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
